import { render, staticRenderFns } from "./ColumnChartCard.vue?vue&type=template&id=27256c12"
import script from "./ColumnChartCard.vue?vue&type=script&lang=js"
export * from "./ColumnChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports